import LaunchButton from "@/components/LaunchButton"
import { Population } from "@/entities/population/model/population.types"
import { Site } from "@/entities/site/model/site.types"
import { faBuilding, faLocationDot, faUserFriends } from "@fortawesome/free-solid-svg-icons"

interface Props {
  establishmentName: string
  populations: Population[]
  sites: Site[]
  onSelectPopulations: () => void
  onSelectSites: () => void
  onSelectWholeEstablishment: () => void
}

function getExamplesText(values: string[], fallback: string) {
  const examples = values.filter(Boolean).slice(0, 3)
  if (!examples.length) return fallback
  return examples.join(", ") + (values.length > examples.length ? "..." : "")
}

export default function PhysicalRiskPerimeterChoiceStep({
  establishmentName,
  populations,
  sites,
  onSelectPopulations,
  onSelectSites,
  onSelectWholeEstablishment
}: Props) {
  return (
    <div className="flex flex-1 flex-col">
      <div className="m-auto flex w-full max-w-[680px] flex-col gap-[15px]">
        <LaunchButton
          description="Le risque concerne tous les lieux et toutes les personnes"
          icon={faBuilding}
          iconBackground="#0E5AA7"
          isCta
          isRow
          onClick={onSelectWholeEstablishment}
          title={`Tout l'établissement ${establishmentName}`}
        />
        <LaunchButton
          description={getExamplesText(
            sites.map((site) => site.name),
            "Chambres, bureaux, cuisine..."
          )}
          icon={faLocationDot}
          isRow
          onClick={onSelectSites}
          title="Des lieux de travail spécifiques"
        />
        <LaunchButton
          description={getExamplesText(
            populations.map((population) => population.name),
            "Éducateurs, encadrement, administratif..."
          )}
          icon={faUserFriends}
          isRow
          onClick={onSelectPopulations}
          title="Des fonctions spécifiques"
        />
      </div>
    </div>
  )
}
